import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import styled from 'styled-components';

import MobileTopBar from 'components/layout/Sidebar/MobileTopBar';

import { NavigationContext } from './NavigationContext';
import Header from '../Header';
import Sidebar from '../Sidebar';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100vh;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  background-color: white;

  @media (max-width: 768px) {
    padding-top: 50px;
    box-sizing: border-box;
  }
`;

const MainContent = styled.div`
  display: flex;
  flex: 1;
  box-sizing: border-box;
  justify-content: center;
  min-height: 0;
`;

const BlurredOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 300px;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  z-index: 6;
`;

interface Props {
  children: React.ReactNode;
}

const Content = ({ children }: Props) => {
  const location = useLocation();
  const [showMobileSidebar, setMobileSidebar] = useState(false);
  const closeMobileSidebar = () => setMobileSidebar(false);

  useEffect(() => {
    // close mobile sidebar on each location change
    closeMobileSidebar();
  }, [location]);

  return (
    <Container>
      <NavigationContext.Provider
        value={{
          closeMobileSidebar,
        }}
      >
        <MobileTopBar setMobileSidebar={setMobileSidebar} />
        {showMobileSidebar && <BlurredOverlay onClick={closeMobileSidebar} />}
        <Sidebar className={showMobileSidebar ? 'mobile' : undefined} />
        <ContentContainer>
          <Header />
          <MainContent>{children}</MainContent>
        </ContentContainer>
      </NavigationContext.Provider>
    </Container>
  );
};

export default Content;
